<div class="animated fadeIn" *ngIf="category">

    <table-component (onEdit)="onEdit($event)"
                     (onAdd)="onAdd()"
                     (onRemove)="onRemove($event)"></table-component>

</div>

<category-notification-emails-edit-component></category-notification-emails-edit-component>
